import Check from '@mui/icons-material/Check';
import ButtonGroup from '@mui/material/ButtonGroup';
import { Button } from '@src/common/components/button/Button';
import { Stack } from '@src/common/components/Stack';
import { css } from '@src/common/styles/Styles';
import { theme } from '@src/common/styles/Theme';
import { useTranslation } from 'react-i18next';

interface Props {
  isMetric: boolean;
  setIsMetric: (isMetric: boolean) => void;
}

export const MeasurementToggle = ({ isMetric, setIsMetric }: Props) => {
  const { t } = useTranslation();

  return (
    <ButtonGroup disableRipple variant="text" className={buttonGroup}>
      <Button
        className={isMetric ? button : `${activeButton} ${button}`}
        onClick={() => setIsMetric(false)}
      >
        <Stack direction="row" alignItems="flex-end" gap={theme.spacing['2']}>
          {!isMetric && <Check />}
          {t('imperial')}
        </Stack>
      </Button>
      <Button
        className={isMetric ? `${activeButton} ${button}` : button}
        onClick={() => setIsMetric(true)}
      >
        <Stack direction="row" alignItems="flex-end" gap={theme.spacing['2']}>
          {isMetric && <Check />}
          {t('metric')}
        </Stack>
      </Button>
    </ButtonGroup>
  );
};

const buttonGroup = css({
  border: '1px solid',
  borderColor: theme.palette.surface.outline,
  borderRadius: '100px',
  width: 'fit-content',
});

const button = css({
  width: '115px',
  transition: 'none',
  color: theme.palette.surface.onSurface,
});

const activeButton = css({
  backgroundColor: theme.palette.secondary.secondaryContainer,
  borderRadius: '100px',
});
